import { getDifficultyColor, getDifficultyLabel } from '@/lib/utils';
import type { DifficultyLevel } from '@/types/exam';
import { cn } from '@/lib/utils';

interface DifficultyBadgeProps {
  difficulty: DifficultyLevel;
  size?: 'sm' | 'md';
}

export function DifficultyBadge({ difficulty, size = 'sm' }: DifficultyBadgeProps) {
  const sizeClasses = size === 'sm'
    ? 'text-[10px] px-1.5 py-0.5'
    : 'text-xs px-2 py-1';

  return (
    <span className={cn(getDifficultyColor(difficulty), sizeClasses, 'rounded-md font-medium border')}>
      {getDifficultyLabel(difficulty)}
    </span>
  );
}
